/*
 * CongregationCreate Messages
 *
 * This contains all the text for the CongregationCreate component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.CongregationCreate.title',
    defaultMessage: 'New Congregation',
  },
  saveButton: {
    id: 'app.containers.CongregationCreate.saveButton',
    defaultMessage: 'Save',
  },
  saveSuccess: {
    id: 'app.containers.CongregationCreate.saveSuccess',
    defaultMessage: 'Congregation has been successfully created.',
  },
  saveFailure: {
    id: 'app.containers.CongregationCreate.saveFailure',
    defaultMessage: 'Error. The congregation could not be created.',
  },
});
